import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export interface Props {
  id: string;
  width?: string;
  mobilehidden?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    id: null,
    width: null,
    mobilehidden: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("th", null, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})